import { fetcher } from '@commenda/utils';
import { TaxAndReportingOnboardingStep } from './tax-and-reporting.types';

type TaxAndReportingOnboardingUpdateProp = {
  step: TaxAndReportingOnboardingStep;
};

export async function updateTaxAndReportingOnboarding(
  corporationId: number,
  body: TaxAndReportingOnboardingUpdateProp
): Promise<Response> {
  return fetcher(`tax-and-accounting/onboarding/${corporationId}`, {
    method: 'POST',
    body,
  });
}
